export const SOURCE_SCHEME = 'source:';

// A Percy citation: [S1], [S1 p. 4], [S1 pp. 4-5], [S1 section "…"], [S1 row 12].
// Captures the sequence number; the rest (the locator) is preserved as display text.
const SOURCE_CITATION_RE = /\[S(\d+)((?:\s+[^\]]*)?)\]/g;

// Skip regions where a citation must not be rewritten — mirrors fp-id-markdown's
// SKIP_REGION_RE: fenced/inline code, existing markdown links/images (including the
// fpentity links produced by linkifyFpIds), and bare URLs.
const SKIP_REGION_RE =
  /(?:^|\n)([ \t]{0,3})(`{3,}|~{3,})[^\n]*\n[\s\S]*?\n\1\2[ \t]*(?=\n|$)|(`+)(?:(?!\3)[\s\S])+?\3|!?\[[^\]\n]*\]\([^)\n]*\)|https?:\/\/\S+/g;

const linkify = (s: string) =>
  s.replace(SOURCE_CITATION_RE, (_m, seq: string, locator: string) => `[S${seq}${locator}](${SOURCE_SCHEME}${seq})`);

// Rewrite `[S#]` citations to markdown links carrying the `source:` scheme so the
// chat-markdown `a` renderer can swap them for SourceChips. Run AFTER linkifyFpIds so
// its links are treated as skip regions.
export const linkifySources = (md: string) => {
  let out = '';
  let last = 0;
  for (const m of md.matchAll(SKIP_REGION_RE)) {
    out += linkify(md.slice(last, m.index));
    out += m[0];
    last = m.index + m[0].length;
  }
  out += linkify(md.slice(last));
  return out;
};
